/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserClassGroupUpdate
 */
export interface UserClassGroupUpdate {
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserClassGroupUpdate
     */
    deleted?: boolean | null;
}

/**
 * Check if a given object implements the UserClassGroupUpdate interface.
 */
export function instanceOfUserClassGroupUpdate(value: object): value is UserClassGroupUpdate {
    return true;
}

export function UserClassGroupUpdateFromJSON(json: any): UserClassGroupUpdate {
    return UserClassGroupUpdateFromJSONTyped(json, false);
}

export function UserClassGroupUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClassGroupUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
    };
}

export function UserClassGroupUpdateToJSON(json: any): UserClassGroupUpdate {
    return UserClassGroupUpdateToJSONTyped(json, false);
}

export function UserClassGroupUpdateToJSONTyped(value?: UserClassGroupUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'deleted': value['deleted'],
    };
}

